import Vue from 'vue'
import VueRouter from 'vue-router'
//首页
import Home from '../pages/home/index.vue'/* 首页 */
import Mine from '../pages/mine/index.vue'/* 我的 */
import Choose from '../pages/choose/index.vue'/* 选妃 */
import List from '../pages/choose/list.vue'/* 选妃列表 */
import Profile from '../pages/choose/profile.vue'/* 选妃详情 */
import Video from '../pages/video/index.vue'/* 视频 */
import Game from '../pages/game/index.vue'/* 游戏 */
import Login from '../pages/login/index.vue'/* 登录 */
import Register from '../pages/login/register.vue'/* 注册 */
import ServiceOnline from '../pages/mine/ServiceOnline.vue'/* 客服列表 */
import ServicePage from '../pages/mine/ServicePage.vue'/* 客服详情界面 */
import Setting from '../pages/mine/Setting.vue'/* 设置 */
import Infomation from '../pages/mine/Infomation.vue'/* 基本信息 */
import Setname from '../pages/mine/Setname.vue'/* 修改姓名 */
import Language from '../pages/mine/Language.vue'/* 语言选择 */
import Setsex from '../pages/mine/Setsex.vue'/* 修改姓名 */
import Recharge from '../pages/mine/Recharge.vue'/* 充值 */
import SetPayPassword from '../pages/mine/SetPayPassword.vue'/* 修改提现密码 */
import SetLoginPassword from '../pages/mine/SetLoginPassword.vue'/* 修改提现密码 */
import setnewPayPassword from '../pages/mine/setnewPayPassword.vue'/* 修改提现密码 */
import Lottery from '../pages/lottery/index.vue'/* 彩票详情 */
import Notice from '../pages/mine/Notice.vue'/* 公告 */
import PlayVideo  from '../pages/video/PlayVideo'/* 视频播放页面 */
import Setbank  from '../pages/mine/Setbank'/* 视频播放页面 */
import BindCard  from '../pages/mine/BindCard'/* 绑定银行卡界面 */
import Withdraw  from '../pages/mine/Withdraw'/* 绑定银行卡界面 */
import Personalreport  from '../pages/mine/Personalreport'/* 个人表报 */
import GameRecord  from '../pages/mine/GameRecord'/* 游戏记录 */
import WithdrawRecord  from '../pages/mine/WithdrawRecord'/* 提现记录 */
import Details from '../pages/mine/details'

Vue.use(VueRouter)

// =========================================================
// 解决 NavigationDuplicated 报错的核心代码
// =========================================================
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}
// =========================================================

const routes = [
    {path:'/',redirect:'/Home',component:Home,meta:{title:'Homepage'}},
    {path:'/Home',name:'home',component:Home,meta:{title:'Homepage'}},
    {path:'/Choose',name:'choose',component:Choose,meta:{title:'Choose a concubine.'}},
    {path:'/List',name:'list',component:List,meta:{title:'List of chosen concubines'}},
    {path:'/Profile',name:'profile',component:Profile,meta:{title:'Details of the selection process for concubines.'}},
    {path:'/Mine',name:'mine',component:Mine,meta:{title:'my'}},
    {path:'/Video',name:'video',component:Video,meta:{title:'Video'}},
    {path:'/Game',name:'game',component:Game,meta:{title:'game'}},
    {path:'/Login',name:'login',component:Login,meta:{title:'Login'}},
    {path:'/Register',name:'register',component:Register,meta:{title:'register'}},
    {path:'/ServiceOnline',name:'ServiceOnline',component:ServiceOnline,meta:{title:'Online customer service'}},
    {path:'/ServicePage',name:'ServicePage',component:ServicePage,meta:{title:'Online customer service'}},
    {path:'/Setting',name:'Setting',component:Setting,meta:{title:'Settings'}},
    {path:'/Infomation',name:'Infomation',component:Infomation,meta:{title:'Basic information'}},
    {path:'/Setname',name:'Setname',component:Setname,meta:{title:'Change real name'}},
    {path:'/Setsex',name:'Setsex',component:Setsex,meta:{title:'Gender revision'}},
    {path:'/Language',name:'Language',component:Language,meta:{title:'Select language'}},
    {path:'/Recharge',name:'Recharge',component:Recharge,meta:{title:'expenses'}},
    {path:'/SetPayPassword',name:'SetPayPassword',component:SetPayPassword,meta:{title:'Managing payment passwords.'}},
    {path:'/setnewPayPassword',name:'setnewPayPassword',component:setnewPayPassword,meta:{title:'Set withdrawal code'}},
    {path:'/SetLoginPassword',name:'SetLoginPassword',component:SetLoginPassword,meta:{title:'Managing login passwords.'}},
    {path:'/Lottery',name:'Lottery',component:Lottery,meta:{title:'Details page'}},
    {path:'/Notice',name:'Notice',component:Notice,meta:{title:'Data presentation'}},
    {path:'/PlayVideo',name:'PlayVideo',component:PlayVideo,meta:{title:'Playing video'}},
    {path:'/Setbank',name:'Setbank',component:Setbank,meta:{title:'Enter your payment card details.'}},
    {path:'/BindCard',name:'BindCard',component:BindCard,meta:{title:'Enter your payment card details.'}},
    {path:'/Withdraw',name:'Withdraw',component:Withdraw,meta:{title:'Withdraw cash'}},
    {path:'/Personalreport',name:'Personalreport',component:Personalreport,meta:{title:'Personal report'}},
    {path:'/WithdrawRecord',name:'WithdrawRecord',component:WithdrawRecord,meta:{title:'Withdrawal record'}},
    {path:'/GameRecord',name:'GameRecord',component:GameRecord,meta:{title:'Work history'}},
    {path:'/detail',name:'Details',component:Details}
];

//生成路由实例
const router = new VueRouter({
    routes
})

// 修改标题路由配置（增加了安全判断，防止访问未定义路由时报错）
router.beforeEach((to, from, next) => {
    if (to.matched && to.matched.length > 0 && to.matched[0].meta && to.matched[0].meta.title) {
        document.title = to.matched[0].meta.title;
    }
    next();
})

export default router